export const setCachedEntry = (storageKey, cacheKey, data) => {
    try {
        let map = {};
        try {
            const raw = localStorage.getItem(storageKey);
            if (raw) {
                map = JSON.parse(raw);
            }
        } catch {
            // corrupted existing data, start fresh
        }
        map[cacheKey] = { data, timestamp: Date.now() };
        localStorage.setItem(storageKey, JSON.stringify(map));
    } catch {
        // localStorage full or unavailable, non-critical
    }
};
